<template>
  <div class="sys-meta">
    <Avatar shape="square" :size="40" slot="avatar" class="meta-avatar">
      <SvgIcon slot="icon" icon-class="bell" />
    </Avatar>
    <div class="meta-body text-black">
      张三<span class="text-grey" style="padding: 0 4px">{{$t('home.AlreadyFriend')}}</span>
    </div>
  </div>
</template>
<script>
// 系统通知的meta
import { Avatar } from 'ant-design-vue'
export default {
  name: 'SysMeta',
  components: {
    Avatar
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
@import url(./meta.less);
.sys-meta {
  .meta();
  .meta-avatar {
    background-color: #ffc757;
  }
  .meta-body {
    line-height: 48px;
  }
}
</style>
